/**
 * @file vendor/async.js
 * @author leeight
 */

exports.mapLimit = require('async.maplimit');
